import { getTokens } from '@/stores/secure';

/**
 * Checks for a stored bearer token and returns the route to redirect to.
 * Web port of the legacy `checkAuthAndRedirect` (decoupled from the router so
 * callers navigate with TanStack Router themselves).
 */
export const resolveAuthLanding = async (routes: {
  auth: string;
  home: string;
}): Promise<string> => {
  try {
    const { bearerToken } = await getTokens();
    return bearerToken ? routes.home : routes.auth;
  } catch {
    return routes.auth;
  }
};
